<template>
  <div class="footer">
    <div
      class="button"
      @click="selectMenu(44)"
      :class="index == 44 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 44" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 44"
      />
      <div>安全监控</div>
    </div>
    <div
      class="button"
      @click="selectMenu(45)"
      :class="index == 45 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 45" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 45"
      />
      <div>产出物库存</div>
    </div>
    <div
      class="button"
      @click="selectMenu(46)"
      :class="index == 46 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 46" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 46"
      />
      <div>产出物入库</div>
    </div>
    <div
      class="button"
      @click="selectMenu(47)"
      :class="index == 47 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 47" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 47"
      />
      <div>产出物出库</div>
    </div>
  </div>
</template>
  
  <script>
export default {
  props: ["index"],
  data() {
    return {
      showPopover: false,
      nowTime: "",
      type: "index",
    };
  },

  methods: {
    selectMenu(index) {
      this.showPopover = false;
      this.$emit("selectMenu", index);
    },
  },
};
</script>
  <style>
.button-footer .button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("~@/assets/botton.png") no-repeat center;
  background-size: 100% 100%;
  width: 200px;
  padding: 10px 0;
  color: #fff;

  cursor: pointer;
}
.button-footer .button img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.el-popover {
  background: unset;
  padding: unset;
  border: unset;
  border-radius: unset;
}
</style>
